import React, {
    createContext,
    ReactNode,
    useContext,
    useMemo,
    useState,
} from "react";

import { ModalContextValues } from "../types/contexts";
import { ModalContent } from "../types/myschedule";

import { AsyncStatuses } from "../../../../types/shared";

const MyScheduleModalContext = createContext<ModalContextValues | null>(null);

export const useMyScheduleModalContext = () => {
    const context = useContext(MyScheduleModalContext);
    if (!context) {
        throw new Error("useModalsContext must be used within a ModalProvider");
    }
    return context;
};

export const MyScheduleModalProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<ModalContent>();
    const [modalRequestStatus, setModalRequestStatus] =
        useState<AsyncStatuses>(undefined);
    const [modalStatusMessage, setModalStatusMessage] = useState<
        string | undefined
    >(undefined);

    const contextValue = useMemo(
        () => ({
            modalContent,
            setModalContent,
            showModal,
            setShowModal,
            modalRequestStatus,
            setModalRequestStatus,
            modalStatusMessage,
            setModalStatusMessage,
        }),
        [showModal, modalContent, modalRequestStatus, modalStatusMessage],
    );

    return (
        <MyScheduleModalContext.Provider value={contextValue}>
            {children}
        </MyScheduleModalContext.Provider>
    );
};
